/* eslint-disable no-useless-escape */
import { PG_ROUTER_ADMIN_PATH } from '../screens/Products/Plural/PgRouterAdmin/pgRouterAdminConfig';

const contentType = {
  MULTIPART: 'multipart',
};

const UiRoutes = {
  TOGGLEENV: '/plural/toggle',
  SIGNUP: '/signup',
  LOGIN: '/login',
  LOGIN_OTP: '/validateOTP',
  FORGOT_PASSWORD: '/forgot-password',
  REGISTER_USER: '/register',
  WELCOME_USER: '/welcome',
  OVERVIEW: '/plural/overview',
  PAYMENT: '/plural/payments',
  REFUNDS: '/plural/refunds',
  PAYOUTS: '/payout/payouts',
  INDIVIDUAL_PAYOUTS: '/payout/individualPayouts',
  BULK_PAYOUTS: '/payout/bulkPayouts',
  BULK_PAYOUT_DETAILS: '/payout/bulkPayouts/:requestReferenceId',
  BULK_PAYOUT_FAILED_RECORDS:
    '/payout/bulkPayoutsFailedRecords/:requestReferenceId',
  PAYOUTS_SETTINGS: '/payout/settings',
  BULK_BENEFICIARIES: '/payout/bulkBeneficiaries',
  PAYOUT_LINKS: '/payout/payoutLinks',
  BENEFICIARIES: '/payout/beneficiaries',
  ROUTING: '/plural/routing',
  API_DOCUMENTATION: '/plural/apiDocumentation',
  SETTLEMENTS: '/plural/settlements',
  SMART_ROUTING: '/plural/smart-routing',
  OFFERS: '/plural/offers',
  OFFERSNEWCAMPAIGN: '/plural/offers/createcampaign',
  OFFERSCLONECAMPAIGN: '/plural/offers/clonecampaign/:campaignId',
  SUBSCRIPTIONS: '/plural/subscriptions',
  PRESENTATIONS: '/plural/presentations',
  PAYMENT_LINKS: '/plural/payment-links',
  PAYMENT_LINK_BULK_UPLOAD_HISTORY: '/plural/payment-links/bulk-upload-history',
  PAYMENT_PAGES: '/plural/payment-pages',
  ANALYTICS: '/plural/analytics',
  SETTINGS: '/plural/settings',
  INTRODUCTION: '/plural/introduction',
  VARIFY_IMEI: '/plural/varify-imei',
  VIEW_GATEWAY_DETAILS: (gateway: string): string =>
    `/plural/smart-routing/view-gateway/${gateway}`,
  CREATE_GATEWAY: '/plural/smart-routing/gateway/create',
  PLANS: '/plural/plans',
  PLANS_HISTORY: '/plural/bulk-upload-history',
  SEARCH_RESULTS: '/plural/search-results',
  REFUND_BULK_UPLOAD_HISTORY: '/plural/refunds/bulk-upload-history',
  ADMIN_CUSTOM_ROUTING: '/plural/admin/custom-routing',
  PG_ROUTER_ADMIN: PG_ROUTER_ADMIN_PATH,
  MERCHANT_LISTING: '/plural/admin/merchant-listing',
  ALL_MERCHANTS: '/all-merchants',
  MERCHANT_ONBOARDING: '/all-merchants/merchant-onboarding',
  MERCHANT_BULK_UPLOAD_HISTIORY: '/all-merchants/merchant-onboarding/bulk-upload-history',
  ADMIN_LOGIN: '/admin/login',
  ADMIN_ANALYTICS: '/plural/admin/analytics',
  ADMIN_USER_MANAGEMENT: '/plural/admin/users',
  MAKER_CHECKER_MAKER: '/plural/admin/maker-checker/maker',
  MAKER_CHECKER_CHECKER: '/plural/admin/maker-checker/checker',
  FORCE_REFUND_ADMIN: '/plural/admin/force-refund',
  FORCE_UPDATE_ORDER_ADMIN: '/plural/admin/force-update-order',
  FEE_CONFIGURATION_ADMIN: '/plural/admin/fee-configuration',
  OPS_IMEI_BULK_UPLOAD_HISTORY: '/plural/admin/ops/imei-bulk-upload-history',
  OPS_IMEI_BULK_UPLOAD_HISTORY_IMEI:
    '/plural/admin/ops/imei-bulk-upload-history/:refId',
  OPS_REFUNDS_BULK_UPLOAD_HISTORY: '/plural/admin/ops/bulk-upload-history',
  OPS_REFUNDS_BULK_UPLOAD_HISTORY_REFUND:
    '/plural/admin/ops/bulk-upload-history/:refId',
  IMEI_BULK_UPLOAD_HISTORY: '/plural/payments/imei-bulk-upload-history',
  CUSTOMIZE_PAYMENT_LINKS: '/plural/payment-links/customize',
  EDGE_CUSTOMIZE_PAYMENT_LINKS: '/edge/payment-links/customize',
  PROFILE: '/profile',
  SUPPORTREQUESTS: '/plural/support',
  SUPPORTREQUESTSDETAILS: '/plural/ticket/:ticketId',
  USER_MANAGEMENT: '/usermanagement',
  HOME: '/home',
  EDGE_TRANSACTIONS: '/edge/payments',
  EDGE_IMEI_BULK_UPLOAD_HISTORY: '/edge/payments/imei-bulk-upload-history',
  EDGE_IMEI_BULK_UPLOAD_HISTORY_IMEI:
    '/edge/payments/imei-bulk-upload-history/:refId',
  EDGE_REFUNDS: '/edge/refunds',
  EDGE_REFUNDS_BULK_UPLOAD_HISTORY: '/edge/refunds/bulk-upload-history',
  EDGE_REFUNDS_BULK_UPLOAD_HISTORY_V3:
    '/payment-gateway/refunds/bulk-upload-history',
  EDGE_REFUNDS_BULK_UPLOAD_HISTORY_LIST_V3:
    '/payment-gateway/refunds/bulk-upload-history/:refId',
  EDGE_REFUNDS_BULK_UPLOAD_HISTORY_REFUND:
    '/edge/refunds/bulk-upload-history/:refId',
  EDGE_OVERVIEW: '/edge/overview',
  EDGE_OVERVIEW_CHECKOUT_INSIGHTS: '/edge/overview/checkout-insights',
  EDGE_SETTLEMENTS: '/edge/settlements',
  UPDATED_EDGE_SETTLEMENTS: '/edge/updatedSettlements',
  EDGE_SETTLEMENT_DETAILS: '/edge/updatedSettlements/:utrNumber',
  EDGE_SETTLEMENT_TRANSACTION_DETAILS: '/edge/updatedSettlements/:utrNumber/:orderId',
  EDGE_PENDING_SETTLEMENTS: '/edge/updatedSettlements/pending',
  EDGE_DISPUTES: '/edge/disputes',
  EDGE_DISPUTE_DETAILS: '/edge/disputes/:chargebackId',
  UNIFIED_MERCHANT_LISTING: '/unified/merchant-listing',
  UNIFIED_MERCHANT_VERSION_LISTING: '/unified/merchant-version-listing',
  EDGE_SETTINGS: '/edge/settings',
  EDGE_PAYMENT_LINKS: '/edge/payment-links',
  EDGE_PAYMENT_LINK_BULK_UPLOAD_HISTORY:
    '/edge/payment-links/bulk-upload-history',
  EDGE_MPR_SETTLEMENTS: '/edge/mpr',
  V3_OVERVIEW: '/payment-gateway/overview',
  V3_PAYMENTS: '/payment-gateway/payments',
  V3_REFUNDS: '/payment-gateway/refunds',
  IMEI_VALIDATION_V3: '/payment-gateway/payments/imei-validation',
  IMEI_BULK_UPLOAD_HISTORY_V3:
    '/payment-gateway/payments/imei-bulk-upload-history',
  IMEI_BULK_UPLOAD_HISTORY_IMEI_V3:
    '/payment-gateway/payments/imei-bulk-upload-history/:refId',
  V3_PAYMENTS_DETAILS: '/payment-gateway/payments/details',
  V3_ORDER_DETAILS: '/payment-gateway/payments/order-details',
  BULK_PAYMENT_DETAILS_HISTORY:
    '/payment-gateway/payments/bulk-payment-details-history',
  V3_REFUND_DETAILS: '/payment-gateway/refunds/order-details',
  V3_REFUND_PAYMENT_DETAILS: '/payment-gateway/refunds/details',
  ODS_DETAIL_PAGE: '/edge/odsDetails',
  UNIFIED_MERCHANT_VERSION_UPDATE: '/unified/merchant-version-update',
  IMEI_VALIDATION: '/edge/transactions/imei-validation',
  COMPLETE_PROFILE: '/complete-profile',
  MDR_ACCEPTANCE: '/user-verification/mdr-acceptance',
  SELECT_PRODUCTS: '/user-verification/product-selection',
  PAN_VERIFICATION: '/user-verification/pan-verification',
  BUSINESS_DETAILS: '/user-verification/business-verification',
  KYC_VERIFICATION: '/user-verification/kyc-verification',
  KYC_AGREEMENT_SIGN: '/user-verification/kyc-sign-agreement',
  VIDEO_KYC_VERIFICATION: '/user-verification/video-kyc-verification',
  UPLOAD_DOCUMENTS: '/user-verification/upload-documents',
  UPLOAD_COMPANY_DOCUMENTS: '/user-verification/upload-documents-company',
  PUBLIC_UPLOAD_COMPANY_DOCUMENTS: '/user-verification/upload-documents-company-director',
  DOCUMENTS_UPLOAD: '/user-verification/upload-documents',
  SOLE_PROP_DOCUMENTS_UPLOAD: '/user-verification/upload-documents-sole-prop',
  PUBLIC_UPLOAD_DOCUMENTS: '/user-verification/upload-documents-director',
  DUMMY_URL: '/user-verification/kyc/status',
  BANK_DETAILS: '/user-verification/bank-account-verification',
  PUBLIC_KYC_AGREEMENT_SIGN: '/user-verification/kyc-sign-agreement-director',
  PARTNER_SUMMARY: '/partner/summary',
  PARTNER_ALL_MERCHANTS: '/partner/all-merchants',
  PARTNER_REVIEW_CHARGES: '/partner/review-charges',
  PARTNER_MERCHANT_ONBOARDING: '/partner/all-merchants/merchant-onboarding',
  PARTNER_MERCHANT_BULK_UPLOAD_HISTIORY: '/partner/all-merchants/merchant-onboarding/bulk-upload-history',
  PARTNER_INVITE_MERCHANT: '/partner/all-merchants/invite-merchant',
  PARTNER_TRANSACTIONS: '/partner/transactions',
  PARTNER_COMMISSIONS: '/partner/commissions',
  PARTNER_REPORTS: '/partner/reports',
  PARTNER_SETTINGS: '/partner/settings',
  MERCHANT_REPORT: '/edge/reports',
  BANK_ACCOUNT_VERIFICATION: '/user-verification/bank-account-verification',
  REVIEW_DETAILS: '/user-verification/review-details',
  BUSINESS_PROOF_SUBMITTION: '/user-verification/business-proof',
  SOFT_REJECTION: '/user-verification/soft-rejection',
  PUBLIC_SOFT_REJECTION_UPLOAD_DOCUMENTS: '/user-verification/soft-rejection-upload-documents-director',
  PROFILE_SUBMITTED: '/user-verification/profile-submitted',
  EMAIL_VERIFICATION: '/email-verification',
  V3_PLANS: '/subscription/plan',
  V3_SUBSCRIPTIONS: '/subscription/subscription',
  V3_PRESENTATIONS: '/subscription/presentation',
  ADMIN_TRANSACTIONS: '/admin/transactions',
  ADMIN_RCU_MERCHANT: '/admin/rcu-merchant',
  REPORT_CUSTOMIZATION: '/partner/reports/customization',
  BRAND_WALLET: '/edge/brand-wallet',
  PAYMENT_MODES_OVERVIEW: '/edge/settings/payment-modes',
  PAYMENT_MODES_DETAILS: '/edge/settings/payment-modes/:tab',
};

const ExternalUrls = { 
  API_DOCUMENTATION_URL: process.env.REACT_APP_API_DOCUMENTATION_URL || 'https://www.pinelabs.com/docs/online-payments/api',
  DOCUMENTATION_URL: process.env.REACT_APP_DOCUMENTATION_URL || 'https://www.pinelabs.com/docs/online-payments/overview',
};

const labels = {
  _login: {},
};

const emailValidationRegex =
  /^[a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

//const passwordValidationRegex = /^(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[a-zA-Z!#$@^%&? "])[a-zA-Z0-9!#$@^%&?]{8,100}$/;

const remarkValidationRegex = /^[a-zA-Z]+([a-zA-Z0-9- ]*)[a-zA-Z0-9]+$/;

const passwordValidationRegex =
  /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{11,}$/;

const gstinValidationRegex =
  /[0-9]{2}[A-Z]{3}[ABCFGHLJPTF]{1}[A-Z]{1}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}/;

const gstinValidationRegexSelfServe = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

const urlValidationRgex =
  /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=+$,\w]+@)?[A-Za-z0-9.-]+(:[0-9]+)?|(?:www.|[-;:&=+$,\w]+@)[A-Za-z0-9.-]+)((?:\/[+~%/.\w-_]*)?\??(?:[-+=&;%@.\w_]*)#?(?:[\w]*))?)/;

const phoneValidationRegex = /^[1-9]\d{9}$/;

const selectedCountryPhoneRegex = {
  India: /^(91)[1-9]\d{9}$/,
};

const UpiRegex = /^[\w\\.\-_]{3,}@[a-zA-Z]{3,}/;

const IndividualPayoutVpaRegex = /^[a-zA-Z0-9.-]{2,256}@[a-zA-Z]{2,64}$/;

const numericValidationRegex = /^(0|[1-9][0-9]*)$/;

const numberValidationRegex = /^[0-9]*$/;

const decimalNumberValidationRegex = /^\d*\.?\d*$/;

const twoDigitAfterDecimalValidationRegex = /^\d*(\.\d{0,2})?$/;

const nameValidationRegex = /^([A-Za-z]{1,}\.?)([ \-'.][A-Za-z]{1,}\.?)*$/;

const alphaNumericWithFullStopAtTheRateUnderScoreRegex = /^[a-zA-Z0-9_@. -]*$/;

const alphaNumericValidationRegex = /^[a-zA-Z0-9 ]*$/;

const alphabetValidationRegex = /^[a-zA-Z. ]*$/;

const nonEmptyValidationRegex = /(.|\s)*\S(.|\s)*/;

const alphaNumericValidationRegexWithoutSpace = /^[a-zA-Z0-9]*$/;

export const alphaNumericValidationRegexWithUnderscoreAndAtSignWithoutSpace = /^[a-zA-Z0-9_@]*$/;

export const alphaNumericValidationRegexWithUnderscoreSignWithoutSpace = /^(?!.*,\s)[a-zA-Z0-9 _,-]+$/;

export const alphaNumericWithUnderScoreHyphenCommaRegexWithSpace = /^[a-zA-Z0-9\s,\\-_]+$/;

export const alphaNumericWithUnderScoreValidationRegexWithoutSpace = /^[a-zA-Z0-9_]*$/;

const alphaNumericValidationRegexWithSingleHyphen = /^(?!.*--)[a-zA-Z0-9-]+$/;

const alphaNumericWithHyphenUnderScoreValidationRegex = /^[a-zA-Z0-9 _-]*$/;

const noWhiteSpaceStringValidationRegex = /^\S*$/;

const alphaNumericWithHashHyphenRegex = /^[a-zA-Z0-9#-]*$/;

const alphaNumericWithHashHyphenUnderScoreRegex = /^[a-zA-Z0-9-#_]*$/;

const alphaNumericWithHashHyphenRegexWithSpace = /^[ a-zA-Z0-9#-]*$/;

const alphaNumericWithHashHyphenSlashRegexWithSpace = /^[ a-zA-Z0-9#/-]*$/;

const ifscCodeValidationRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;

const PANValidationRegex = /[A-Z]{5}[0-9]{4}[A-Z]{1}/;

const PANValidationRegexSelfServe = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;

const CIN_REGEX = /^[LU]\d{5}[A-Z]{2}\d{4}[A-Z]{3}\d{6}$/i;
const LLPIN_REGEX = /^[A-Z]{3}-?\d{4}$/i;

const bankAccountValidationRegex = /^\d{9,18}$/;


const TicketSubject = /^[ a-zA-Z0-9\\.\\,\\'\\-\\?]{5,256}$/;

const TicketDesc = /^[ a-zA-Z0-9\\.\\,\\'\\-\\?]{5,1024}$/;

const alphaNumericWithHashHyphenPercentRegex = /^[ a-zA-Z0-9#%-]*$/;

const rupeeSymbol = '₹';
const usdSymbol = '$';
const aedSymbol = 'AED';
const URL_VALIDATOR =
  /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/;

const numberWithCommaRegex = /^[0-9][0-9,]*$/;

export {
  contentType,
  UiRoutes,
  labels,
  emailValidationRegex,
  remarkValidationRegex,
  passwordValidationRegex,
  gstinValidationRegex,
  urlValidationRgex,
  phoneValidationRegex,
  numericValidationRegex,
  numberValidationRegex,
  decimalNumberValidationRegex,
  nameValidationRegex,
  alphaNumericWithFullStopAtTheRateUnderScoreRegex,
  twoDigitAfterDecimalValidationRegex,
  alphaNumericValidationRegex,
  alphabetValidationRegex,
  noWhiteSpaceStringValidationRegex,
  selectedCountryPhoneRegex,
  alphaNumericWithHashHyphenRegex,
  alphaNumericWithHashHyphenUnderScoreRegex,
  alphaNumericWithHashHyphenRegexWithSpace,
  alphaNumericWithHashHyphenSlashRegexWithSpace,
  alphaNumericWithHyphenUnderScoreValidationRegex,
  alphaNumericValidationRegexWithoutSpace,
  ifscCodeValidationRegex,
  PANValidationRegex,
  nonEmptyValidationRegex,
  alphaNumericWithHashHyphenPercentRegex,
  rupeeSymbol,
  UpiRegex,
  IndividualPayoutVpaRegex,
  TicketSubject,
  TicketDesc,
  URL_VALIDATOR,
  alphaNumericValidationRegexWithSingleHyphen,
  numberWithCommaRegex,
  gstinValidationRegexSelfServe,
  PANValidationRegexSelfServe,
  usdSymbol,
  aedSymbol,
  LLPIN_REGEX,
  CIN_REGEX,
  bankAccountValidationRegex,
  ExternalUrls
};

export const localStorageKeys = {
  AUTH_TOKEN: 'PLURAL_XT_MERCHANT_DASH_LOGGED_IN',
};

export const ACCESS_TEST_CREDENTIALS_REDIRECT_KEY = 'accessTestCredentialsRedirect';

export const PER_PAGE_LIMIT = 10;
export const DEFAULT_PER_PAGE_FOR_DYNAMIC = 20;

export const MIN_ATTEMPTS_REMAINING_TO_SHOW_WARNING = 2;

export const PAYOUT_REQUEST_DATE_FORMAT = 'yyyy-MM-dd';

export const DATE_FORMAT_YYYY_MM_DD = 'yyyy-MM-dd';

export const MPR_START_DATE = new Date(2025, 1, 1);

export const FILTER_KEYS_MAPPING = {
  customerId: 'Customer ID',
  'Customer ID': 'customerId',
  customerPhone: 'Customer Phone',
  'Customer Phone': 'customerPhone',
  customerEmail: 'Customer Email',
  'Customer Email': 'customerEmail',
  transactionId: 'Transaction ID',
  'Transaction ID': 'transactionId',
  merchantOrderId: 'Merchant Order ID',
  'Merchant Order ID': 'merchantOrderId',
  orderId: 'Order ID',
  'Order ID': 'orderId',
  amount: 'Amount',
  Amount: 'amount',
  refundId: 'Refund ID',
  'Refund ID': 'refundId',
  RFU1: 'RFU1',
  RFU2: 'RFU2',
  RFU3: 'RFU3',
  RFU4: 'RFU4',
  RFU5: 'RFU5',
};

export const CUSTOM_ERROR_HANDLING_CODES = {
  '3090': true,
  '3130': true, // CREDENTIALS_NOT_VALID
  '3070': true, // USER_DOES_NOT_EXISTS
  '3220': true, // PASSWORD_MISMATCH
  '3480': true, // REFUND_NOT_ALLOWED_ON_THIS_ORDER_ID / REFUND_AMOUNT_NOT_ALLOWED
  '3490': true, // ALREADY_REFUNDED
};

export const COMMON_ERROR_CODES = {
  '3060': 'Something went wrong! Please try again.',
};

export const ONBOARDING_STATUS_OPTIONS = [
  { value: 'ALL', label: 'All' },
  { value: 'PENDING', label: 'Pending' },
  { value: 'APPROVED', label: 'Approved' },
  { value: 'REJECTED', label: 'Rejected' },
];

export const DOWNLOAD_FILE_MORE_THAN_EXPECTED_RECORD_ERROR_MESSAGE =
  'MORE_THAN_EXPECTED_RECORD';

export const SEARCH_DELAY_BUFFER = 200;
export const REFRESH_TOKEN_MARGINAL_TIME = 10;
export const DISPUTES_FEATURE_API_ENABLED = true;
export const MAX_DATE_RANGE_DAYS = 93;

export const DEFAULT_VALIDATION_ERROR = 'Invalid Input';
export const DEFAULT_API_ERROR = 'Something went wrong!';
export const DEFAULT_API_SUCCESS = 'Success';
export const DEFAULT_URL_VAIDATION_ERROR = 'URl is not valid';
export const PDF_UPLOAD_INVALID_FILE_ERROR = "Couldn't read this PDF. Upload a valid PDF";
export const SETTINGS_TAB_CONSTANTS = {
  general: { label: 'General', value: 'general' },
  checkoutTheme: { label: 'Checkout', value: 'checkoutTheme' },
  credentials: { label: 'Credentials', value: 'credentials' },
  webhook: { label: 'Webhook', value: 'webhook' },
  customization: { label: 'Customization', value: 'customization' },
  merchantDetails: { label: 'Merchant Details', value: 'merchantDetails' },
};

Object.freeze(SETTINGS_TAB_CONSTANTS);

export const LOGIN_CONSTANTS = {
  ZERO: 0,
  OTP_LENGTH: 6,
  LOGIN_OTP_EXP_TIME_IN_SECONDS: 180,
  FETCH_LOGIN_OTP_API_TYPE_FETCH: 'FETCH',
  FETCH_LOGIN_OTP_API_TYPE_RESEND: 'RESEND',
};

export const ERROR_CONSTANTS = {
  PASSWORD_EXPIRED: 'PASSWORD_EXPIRED',
  ACCOUNT_IS_BLOCKED: 'ACCOUNT_IS_BLOCKED',
  OTP_IS_NOT_VALID: 'OTP_IS_NOT_VALID',
  USER_IS_TERMINATED: 'USER_IS_TERMINATED',
  INTERNAL_SERVER_ERROR: 'INTERNAL_SERVER_ERROR',
  MAX_OTP_ATTEMPTS_LIMIT_REACHED: 'MAX_OTP_ATTEMPTS_LIMIT_REACHED',
  OTP_EXPIRED: 'OTP_EXPIRED',
  MAX_RESET_PASSWORD_LIMIT_REACHED: 'MAX_RESET_PASSWORD_LIMIT_REACHED',
  USER_DOES_NOT_EXISTS: 'USER_DOES_NOT_EXISTS',
  USER_NOT_REGISTERED_AS_ADMIN: 'USER_NOT_REGISTERED_AS_ADMIN',
};

export const keyTerms = {
  pg: 'Payment Gateway',
  fee: 'Fees',
  tax: 'Tax',
  type: 'Type',
  debit: 'Debit',
  notes: 'Notes',
  amount: 'Amount',
  credit: 'Credit',
  method: 'Method',
  status: 'Status',
  on_hold: 'On Hold',
  settled: 'Settled',
  currency: 'Currency',
  card_type: 'Card Type',
  entity_id: 'Entity ID',
  created_at: 'Created At',
  payment_id: 'Payment ID',
  settled_at: 'Settled At',
  card_issuer: 'Card Issuer',
  createDtStr: 'Created On',
  credit_type: 'Credit Type',
  grossAmount: 'Gross Amount',
  card_network: 'Card Network',
  order_receipt: 'Order Receipt',
  settlement_id: 'Settlement ID',
  settlement_utr: 'Settlement UTR',
  transactionPLID: 'Transaction PLID',
  mode: 'Mode',
  PayUID: 'PayUID',
  bankName: 'Bank Name',
  requestID: 'Request ID',
  issuingBank: 'Issuing Bank',
  requestDate: 'Request Date',
  merchant_UTR: 'Merchant UTR',
  requestAction: 'Request Action',
  requestAmount: 'Request Amount',
  merchantNetAmount: 'Merchant NetAmount',
  merchantServiceFee: 'Merchant ServiceFee',
  payID: 'Pay ID',
  orderNo: 'Order Number',
  'date&time': 'Date & Time',
  errorCode: 'Error Code',
  bankReferenceNo: 'Bank Reference Number',
  transactionType: 'Transaction Type',
  errorDescription: 'Error Description',
  CCAvenueReferenceNo: 'CC Avenue Reference Number',
  NoUpiAccountAdded: 'No UPI Account Added!',
  NoCurrentAccountAdded: 'No Current Account Added!',
  utrNumber: 'UTR'
};

export const PUBLIC_KEY_CONFIGURED_CONSTANTS = {
  name: 'Merchant Public Key',
  active: 'Configured',
  disable: 'Not Configured',
  configure: 'Configure Merchant Public Key',
  editConfigration: 'Edit Merchant Public Key',
};

export const PAYOUT_SCHEDULE_LIST_TYPE = 'payLater';
export const PAYOUT_REGULAR_LIST_TYPE = 'payNow';

export const PUBLIC_KEY_LENGTH = 10;

export const MERCHANT_VERSION_V2 = 'v2';
export const MERCHANT_VERSION_V21 = 'v21';

Object.freeze(LOGIN_CONSTANTS);
Object.freeze(ERROR_CONSTANTS);

export const PAYOUT_LISTING_NO_RECORD_ERROR_CODE = '500110';

export const MILLISECONDS_IN_24_HOURS = 86400000;
export const MILLISECONDS_IN_6_HOURS = 21600000;
export const MALICIOUS_DATA_ERROR_CODES = ['500707'];
export const VIDEO_KYC_CHILD_WINDOW_TIMEOUT = 30 * 60 * 1000;

// payment modes
export const EMI_PAYMENT_MODES = {
  EMI: 4,
  DEBIT_EMI: 14,
};
export const MINIMUM_PASSWORD_LENGTH = 11;
export const OLDER_PASSWORD_LENGTH = 8;
export const MAXIMUM_PASSWORD_LENGTH = 100;

export enum HTTP_CODES {
  UNAUTHORIZED_CODE = 401,
  FORBIDDEN_CODE = 403,
}

export enum CurrencyNumericCode {
  INR = 356,
}

// Value is btoa('PLURAL_DASHBOARD_SECRET_KEY')
export const PLURAL_SECRET_KEY = 'UExVUkFMX0RBU0hCT0FSRF9TRUNSRVRfS0VZ';

export const PRODUCTS = {
  ROUTER: 'Router',
  EDGE: 'Edge',
  PAYOUT: 'Payout',
  COMPLETE_PROFILE: 'Complete Profile',
  DEFAULT: 'Default',
  SUBSCRIPTIONS: 'Subscriptions'
};

// Product ID to Product Name mapping
export const PRODUCT_ID_TO_NAME_MAP = {
  1: PRODUCTS.EDGE,
  2: PRODUCTS.ROUTER,
  3: PRODUCTS.PAYOUT,
  4: PRODUCTS.SUBSCRIPTIONS,
};

export const CleverTapEventNames = {
  LOGIN_SUCCESSFUL: 'User login successful',
  DOWNLOAD_FAILED: 'File download failed',
  DOWNLOAD_SUCCESS: 'File download successful',
  CKYC_MOBILE_NUMBER_SKIPPED:'CKYC mobile number skipped',
  UD_SIGN_UP_EXITED_SIGN_IN: 'UD_SIGN_UP_EXITED_SIGN_IN',
  UD_SIGN_UP_EXITED_CREATE_ACCOUNT: 'UD_SIGN_UP_EXITED_CREATE_ACCOUNT',
  UD_SIGN_UP_SHOWN: 'UD_SIGN_UP_SHOWN',
  UD_LOGIN_SHOWN: 'UD_LOGIN_SHOWN',
  UD_LOGIN_PAGE_EXITED_SIGN_UP: 'UD_LOGIN_PAGE_EXITED_SIGN_UP',
  UD_LOGIN_PAGE_EXITED_FORGOT_PASSWORD: 'UD_LOGIN_PAGE_EXITED_FORGOT_PASSWORD',
  LOGIN_SUCCESS: 'Login successful',
  UD_RESET_PASSWORD_SHOWN: 'UD_RESET_PASSWORD_SHOWN',
  UD_RESET_PASSWORD_EXITED_CANCEL: 'UD_RESET_PASSWORD_EXITED_CANCEL',
  UD_RESET_PASSWORD_EXITED_SEND_OTP: 'UD_RESET_PASSWORD_EXITED_SEND_OTP',
  OVERVIEW_PAGE_SHOWN: 'Overview page shown',
  SIDEBAR_TAB_CLICKED_PAYMENT: 'Sidebar Payment Tab Clicked',
  SIDEBAR_TAB_CLICKED_REFUNDS: 'Sidebar Refunds Tab Clicked',
  SIDEBAR_TAB_CLICKED_SETTLEMENTS: 'Sidebar Settlements Tab Clicked',
  SIDEBAR_TAB_CLICKED_SMART_ROUTING: 'SIDEBAR_TAB_CLICKED_SMART_ROUTING',
  SIDEBAR_TAB_CLICKED_OFFERS: 'SIDEBAR_TAB_CLICKED_OFFERS',
  SIDEBAR_TAB_CLICKED_PAYMENT_LINKS: 'Sidebar Payment Links Tab Clicked',
  SIDEBAR_TAB_CLICKED_PAYMENT_PAGES: 'SIDEBAR_TAB_CLICKED_PAYMENT_PAGES',
  SIDEBAR_TAB_CLICKED_PLANS: 'SIDEBAR_TAB_CLICKED_PLANS',
  SIDEBAR_TAB_CLICKED_SUBSCRIPTIONS: 'SIDEBAR_TAB_CLICKED_SUBSCRIPTIONS',
  SIDEBAR_TAB_CLICKED_ANALYTICS: 'SIDEBAR_TAB_CLICKED_ANALYTICS',
  SIDEBAR_TAB_CLICKED_SETTINGS: 'Sidebar Settings Tab Clicked',
  SIDEBAR_TAB_CLICKED_INDIVIDUAL_PAYOUTS: 'Sidebar Individual Payouts Tab Clicked',
  SIDEBAR_TAB_CLICKED_BULK_PAYOUTS: 'Sidebar Bulk Payouts Tab Clicked',
  SIDEBAR_TAB_CLICKED_PAYOUTS_SETTING: 'Sidebar Payouts Settings Tab Clicked',
  SIDEBAR_TAB_CLICKED_BRAND_WALLET: 'Sidebar Brand Wallet Tab Clicked',
  PAYMENT_DATE_RANGE_CLICKED: 'Payments Date range clicked',
  PAYMENT_DATE_RANGE_CHANGED: 'Payments Date range changed',
  PAYMENT_TRANSACTION_DETAILS_VIEWED:
    'Payments Transaction L2 screen viewed',
  PAYMENT_FILTER_APPLIED: 'Payments Filter Applied',
  PAYMENT_CUSTOMISE_COLUMN_SHOWN: 'Payments Customise column showns',
  PAYMENT_REFUND_ACTION_CLICKED: 'Payments Refund action clicked',
  PAYMENT_REFUND_INITIATED: 'Payemnts Refund initiated',
  PAYMENT_REFUND_SUCCESSFUL: 'Payments Refund Initiated Successfully',
  PAYMENT_REFUND_FAILED: 'Payments Refund failed',
  REFUND_DATE_RANGE_CLICKED: 'Refund date range clicked',
  REFUND_DATE_RANGE_CHANGED: 'Refund date range changed',
  REFUND_DETAILS_VIEWED: 'Refund L2 screen viewed',
  REFUND_FILTER_APPLIED: 'Refund filter applied',
  REFUND_CUSTOMISE_COLUMN_SHOWN: 'Refund customise column showns',
  REFUND_REFUND_ACTION_CLICKED: 'Refund action clicked',
  REFUND_BULK_DETAILS_VIEWED: 'Refund bulk details viewed',
  PAYMENT_DOWNLOAD_CLICKED: 'Payments Download button clicked',
  IMEI_BULK_UPLOAD_HISTORY_SHOWN: 'IMEI bulk upload history shown',
  IMEI_BULK_DETAILS_SHOWN: 'IMEI bulk details shown',
  SETTLEMENT_DOWNLOAD_CLICKED: 'Settlements download button clicked',
  SETTLEMENT_FILTER_APPLIED: 'Settlements filter applied',
  SETTLEMENT_DETAILS_VIEWED: 'Settlements view details L2 screen viewed',
  SETTLEMENT_MPR_VIEWED: 'Settlements MPR screen viewed',
  SETTLEMENT_FAQ_VIEWED: 'Settlements FAQ viewed',

    // Disputes Events
  SIDEBAR_TAB_CLICKED_DISPUTES: 'Sidebar Chargebacks Tab Clicked',
  DISPUTES_DATE_RANGE_CHANGED: 'Disputes Date Range Changed',
  DISPUTES_STATUS_FILTER_APPLIED: 'Disputes Status Filter Applied',
  DISPUTES_SEARCH_PERFORMED: 'Disputes Search Performed',
  DISPUTES_SORT_APPLIED: 'Disputes Sort Applied',
  DISPUTE_PAGINATION_CLICKED: 'Disputes Pagination Clicked',
  DISPUTES_DOWNLOAD_CLICKED: 'Disputes Download Button Clicked',
  DISPUTES_UPLOADED_DOCUMENT_DOWNLOAD_CLICKED: 'Disputes Uploaded Document Download Clicked',
  DISPUTES_ROW_EXPANDED: 'Disputes Row Expanded',
  DISPUTES_DISPUTE_ID_COPIED: 'Disputes Dispute ID Copied',
  DISPUTES_PAYMENT_ID_COPIED: 'Disputes Payment ID Copied',
  DISPUTES_FIELD_COPIED: 'Disputes Field Copied',
  DISPUTES_HELP_DRAWER_OPENED: 'Disputes Help Drawer Opened',
  DISPUTES_HELP_DRAWER_CLOSED: 'Disputes Help Drawer Closed',
  DISPUTES_ACTION_DRAWER_OPENED: 'Disputes Action Drawer Opened',
  DISPUTES_ACTION_DRAWER_CLOSED: 'Disputes Action Drawer Closed',
  DISPUTES_BACK_BUTTON_CLICKED: 'Disputes Back Button Clicked',
  DISPUTES_VIEW_DETAILS_CLICKED: 'Disputes View Details Clicked',

  CONTACT_SUPPORT_SHOWN: 'CONTACT_SUPPORT_SHOWN',
  CONTACT_SUPPORT_EXITED_CLOSE: 'CONTACT_SUPPORT_EXITED_CLOSE',
  CONTACT_SUPPORT_MAIL_ID_CLICKED: 'CONTACT_SUPPORT_MAIL_ID_CLICKED',
  DOCUMENTATION_CLICKED: 'DOCUMENTATION_CLICKED',
  USER_MANAGEMENT_SHOWN: 'User management screen shown',
  USER_MANAGEMENT_CLICKED_PROFILE: 'USER_MANAGEMENT_CLICKED_PROFILE',
  USER_MANAGEMENT_CLICKED_SETTINGS: 'USER_MANAGEMENT_CLICKED_SETTINGS',
  USER_MANAGEMENT_ROLE_CREATE_CLICKED: 'User management role create clicked',
  USER_MANAGEMENT_ROLE_CREATED_SUCCESS: 'User management role created successfully',
  USER_MANAGEMENT_ROLE_CREATED_FAILED: 'User management role create failed',
  USER_MANAGEMENT_USER_CREATE_CLICKED: 'User management user create clicked',
  USER_MANAGEMENT_USER_CREATED_SUCCESS: 'User management user created successfully',
  USER_MANAGEMENT_USER_CREATED_FAILED: 'User management user create failed',
  USER_MANAGEMENT_USER_DELETE_CLICKED: 'User management user delete clicked',
  USER_MANAGEMENT_USER_DELETE_SUCCESS: 'User management user deleted successfully',
  USER_MANAGEMENT_USER_DELETE_FAILED: 'User management user delete failed',
  USER_MANAGEMENT_USER_UPDATE_CLICKED: 'User management user update clicked',
  USER_MANAGEMENT_USER_UPDATE_SUCCESS: 'User management user updated successfully',
  USER_MANAGEMENT_USER_UPDATE_FAILED: 'User management user update failed',
  USER_MANAGEMENT_USER_RESEND_INVITE_CLICKED: 'User management user resend invite clicked',
  USER_MANAGEMENT_USER_RESEND_INVITE_SUCCESS: 'User management user resend invite successfully',
  USER_MANAGEMENT_USER_RESEND_INVITE_FAILED: 'User management user resent invite failed',
  GENERAL_SETTINGS_URL_CHANGED: 'GENERAL_SETTINGS_URL_CHANGED',
  CHECKOUT_SETTINGS_THEME_CHANGED: 'CHECKOUT_SETTINGS_THEME_CHANGED',
  SETTINGS_CREDENTIALS_SHOWN: 'Settings credential screen shown',
  SETTINGS_CREDENTIALS_COPIED_MID: 'Settings credential screen copied Mid',
  SETTINGS_CREDENTIALS_COPIED_ACCESS_CODE:
    'Settings credential screen copied access code',
  SETTINGS_CREDENTIALS_COPIED_SECRET_KEY:
    'Settings credential screen copied secret key',
  SETTINGS_WEBHOOK_SHOWN: 'Settings webhook URL screen shown',
  SETTINGS_WEBHOOK_UPDATED: 'Settings webhook updated',
  SETTINGS_PAYMENT_LINK_WEBHOOK_SHOWN: 'Settings payment link webhook screen shown',
  SETTINGS_PAYMENT_LINK_WEBHOOK_UPDATED: 'Settings payment link webhook updated',
  PAYMENT_PAGES_REDIRECTED: 'PAYMENT_PAGES_REDIRECTED',
  PAYMENT_LINKS_BULK_UPLOAD_HISTORY_VIEWED:
    'PAYMENT_LINKS_BULK_UPLOAD_HISTORY_VIEWED',
  PAYMENT_LINKS_FILTERS_APPLIED: 'Payment links filters applied',
  PAYMENT_LINKS_DOWNLOAD_CLICKED: 'Payment links download button clicked',
  PAYMENT_LINK_INDIVIDUAL_CREATED_SUCCESS: 'Payment links individual created',
  PAYMENT_LINK_INDIVIDUAL_CREATED_FAILED: 'Payment links individual create failed',
  REFUND_BULK_UPLOAD_HISTORY_SHOWN: 'REFUND_BULK_UPLOAD_HISTORY_SHOWN',
  REFUND_BULK_UPLOAD_SUCCESS: 'REFUND_BULK_UPLOAD_SUCCESS',
  REFUND_REPORT_DOWNLOADED: 'Refunds Download button clicked',
  PAYMENT_REPORT_DOWNLOADED: 'PAYMENT_REPORT_DOWNLOADED',
  OFFERS_REPORT_DOWNLOADED: 'OFFERS_REPORT_DOWNLOADED',
  OVERVIEW_REPORT_DOWNLOADED: 'OVERVIEW_REPORT_DOWNLOADED',
  LOGIN_OTP_PAGE_SHOWN: 'LOGIN_OTP_PAGE_SHOWN',
  LOGIN_OTP_SUBMITTED: 'LOGIN_OTP_SUBMITTED',
  LOGIN_OTP_ERROR_MESSAGE_SHOWN: 'LOGIN_OTP_ERROR_MESSAGE_SHOWN',
  LOGIN_OTP_RESENT: 'LOGIN_OTP_RESENT',
  INCOMPATIBLE_DEVICE_DIALOG_SHOWN: 'INCOMPATIBLE_DEVICE_DIALOG_SHOWN',
  INDIVIDUAL_PAYOUTS_CANCEL_CLICKED: 'Individual Payouts cancel payout clicked',
  INDIVIDUAL_PAYOUTS_CANCEL_SUCCESS: 'Individual Payouts cancel payout successful',
  INDIVIDUAL_PAYOUTS_CANCEL_FAILED: 'Individual Payouts cancel payout failed',
  INDIVIDUAL_PAYOUTS_RESCHEDULE_SUCCESS: 'Individual Payouts reschedule payout successful',
  INDIVIDUAL_PAYOUTS_RESCHEDULE_CLICKED: 'Individual Payouts reschedule payout clicked',
  INDIVIDUAL_PAYOUTS_RESCHEDULE_FAILED: 'Individual Payouts reschedule payout failed',
  INDIVIDUAL_PAYOUTS_FILTER_APPLIED: 'Individual Payouts filters applied',
  INDIVIDUAL_PAYOUTS_SIDE_MODAL_OPEN: 'Individual Payouts L2 screen opened',
  PRODUCT_SELECTED: 'product_selected',
  PRODUCT_SELECTION_FAILED: 'product_selection_failed',
  PRODUCT_SELECTION_SCREEN_VIEWED: 'product_selection_screen_viewed',
  BUSINESS_PROOF_SCREEN_VIEWED: 'business_proof_screen_viewed',
  PROFILE_SUBMITTED_SCREEN_VIEWED: 'profile_submitted_screen_viewed',
  PAN_ENTRY_SCREEN_VIEWED: 'pan_entry_screen_viewed',
  PAN_ENTERED: 'pan_entered',
  PAN_VERIFICATION_SUCCESS: 'pan_verification_success',
  PAN_VERIFICATION_FAILED: 'pan_verification_failed',
  GSTIN_FETCH_ATTEMPTED: 'gstin_fetch_attempted',
  GSTIN_FETCHED_SUCCESSFULLY: 'gstin_fetched_successfully',
  GSTIN_FETCH_FAILED: 'gstin_fetch_failed',
  GSTIN_SELECTED: 'gstin_selected',
  GSTIN_FILLED_MANUALLY: 'gstin_filled_manually',
  GSTIN_MANUAL_VERIFICATION_SUCCESS: 'gstin_manual_verification_success',
  GSTIN_MANUAL_VERIFICATION_FAILED: 'gstin_manual_verification_failed',
  PAN_GSTIN_SECTION_COMPLETED: 'pan_gstin_section_completed',
  PAN_GST_FAILED: 'pan_gst_failed',
  BUSINESS_DETAILS_SCREEN_VIEWED: 'business_details_screen_viewed',
  BUSINESS_WEBSITE_ENTERED: 'business_website_entered',
  PRIVACY_POLICY_ENTERED: 'privacy_policy_entered',
  REFUND_POLICY_ENTERED: 'refund_policy_entered',
  ANNUAL_TURNOVER_SELECTED: 'annual_turnover_selected',
  BUSINESS_CATEGORY_SELECTED: 'business_category_selected',
  BUSINESS_SUBCATEGORY_SELECTED: 'business_subcategory_selected',
  BUSINESS_DETAILS_SAVED: 'business_details_saved',
  BUSINESS_DETAILS_FAILED: 'business_details_failed',
  KYC_SCREEN_VIEWED: 'kyc_screen_viewed',
  EKYC_CONSENT_CHECKBOX_CHECKED: 'ekyc_consent_checkbox_checked',
  VERIFY_IDENTITY_CLICKED: 'verify_identity_clicked',
  DIGILOCKER_CONSENT_CHECKBOX_CHECKED: 'digilocker_consent_checkbox_checked',
  CONTINUE_TO_DIGILOCKER_CLICKED: 'continue_to_digilocker_clicked',
  AADHAAR_DETAILS_FETCHED: 'aadhaar_details_fetched',
  KYC_SUCCESSFUL_PROCEED_NEXT: 'kyc_successful_proceed_next',
  KYC_VERIFICATION_FAILED: 'kyc_verification_failed',
  VKYC_SCREEN_VIEWED: 'vkyc_screen_viewed',
  VKYC_START_CTA_ENABLED: 'vkyc_start_cta_enabled',
  VKYC_START_CTA_DISABLED: 'vkyc_start_cta_disabled',
  VKYC_START_CLICKED: 'vkyc_start_clicked',
  VKYC_REDIRECTED_TO_IDFY: 'vkyc_redirected_to_idfy',
  VKYC_SESSION_COMPLETED: 'vkyc_session_completed',
  VKYC_RESULT_SUCCESS: 'vkyc_result_success',
  VKYC_RESULT_FAILED: 'vkyc_result_failed',
  VKYC_RETRY_CLICKED: 'vkyc_retry_clicked',
  VKYC_PROCEED_CLICKED: 'vkyc_proceed_clicked',
  VKYC_COMPLETED_PROCEED_NEXT: 'vkyc_completed_proceed_next',
  VKYC_FAILED: 'vkyc_failed',
  SIGNUP_INITIATED: 'signup_initiated',
  LOGIN_ATTEMPTED: 'login_attempted',
  SIGNUP_COMPLETED: 'signup_completed',
  BANK_DETAILS_SCREEN_VIEWED: 'bank_details_screen_viewed',
  BANK_DETAILS_SAVED_SUCCESSFULLY: 'bank_details_saved_successfully',
  BANK_DETAILS_FAILED: 'bank_details_failed',
  PROCEED_TO_NEXT_STAGE_CLICKED: 'proceed_to_next_stage_clicked',
  REVIEW_DETAILS_SCREEN_VIEWED: 'review_details_screen_viewed',
  REVIEW_DETAILS_FAILED: 'review_details_failed',
  TERMS_AND_CONDITIONS_AGREED: 'terms_and_conditions_agreed',
  PROFILE_SUBMISSION_SUCCESSFUL: 'profile_submission_successful',
  EDIT_PAN_GST_CLICKED: 'edit_pan_gst_clicked',
  EDIT_BUSINESS_DETAILS_CLICKED: 'edit_business_details_clicked',
  EDIT_KYC_VERIFICATION_CLICKED: 'edit_kyc_verification_clicked',
  EDIT_BANK_DETAILS_CLICKED: 'edit_bank_details_clicked',
  RESUBMIT_INFORMATION_CLICKED: 'resubmit_information_clicked',
  PROFILE_REJECTED_NOTIFICATION_SEEN: 'profile_rejected_notification_seen',
  BANK_ACCOUNT_ENTERED: 'bank_account_entered',
  CONFIRM_BANK_ACCOUNT_ENTERED: 'confirm_bank_account_entered',
  IFSC_CODE_ENTERED: 'ifsc_code_entered',

  // Sign Up flow events
  SIGNUP_FULLNAME_ENTERED: 'signup_fullname_entered',
  SIGNUP_EMAIL_ENTERED: 'signup_email_entered',
  SIGNUP_PHONE_ENTERED: 'signup_phone_entered',
  SIGNUP_PASSWORD_ENTERED: 'signup_password_entered',
  SIGNUP_CONFIRM_PASSWORD_ENTERED: 'signup_confirm_password_entered',
  SIGNUP_MOBILE_UNIQUE_SUCCESS: 'signup_mobile_unique_success',
  SIGNUP_MOBILE_UNIQUE_FAILURE: 'signup_mobile_unique_failure',
  SIGNUP_EMAIL_UNIQUE_SUCCESS: 'signup_email_unique_success',
  SIGNUP_EMAIL_UNIQUE_FAILURE: 'signup_email_unique_failure',
  SIGNUP_CONTINUE_FAIL: 'signup_continue_fail',
  SIGNUP_SIGNIN_FAILURE: 'signup_signin_failure',

  // Confirm Email Page events
  CONFIRM_EMAIL_PAGE_LOAD: 'confirm_email_page_load',
  CONFIRM_EMAIL_RESEND_CLICK: 'confirm_email_resend_click',
  CONFIRM_EMAIL_RESEND_SUCCESS: 'confirm_email_resend_success',
  CONFIRM_EMAIL_RESEND_FAILURE: 'confirm_email_resend_failure',
  CONFIRM_EMAIL_EDIT_EMAIL_CLICK: 'confirm_email_edit_email_click',
  VERIFICATION_LINK_PAGE_LOAD: 'verification_link_page_load',
  VERIFICATION_LINK_SUCCESS: 'verification_link_success',
  VERIFICATION_LINK_FAILURE: 'verification_link_failure',
  VERIFICATION_LINK_INVALID: 'verification_link_invalid',

  // PAN & GST flow events
  PAN_VERIFY_BUTTON_CLICKED: 'pan_verify_button_clicked',
  SOLE_PROP_JOURNEY_INVOKED: 'sole_prop_journey_invoked',
  COMPANY_JOURNEY_INVOKED: 'company_journey_invoked',
  PARTNERSHIP_JOURNEY_INVOKED: 'partnership_journey_invoked',
  CKYC_OTP_RESEND_SUCCESS: 'ckyc_otp_resend_success',
  CKYC_OTP_RESEND_FAILURE: 'ckyc_otp_resend_failure',

  // Document upload events
  PCI_DSS_CHECKBOX_TICKED: 'pci_dss_checkbox_ticked',

  // Review Details events
  EDIT_DOCUMENTS_CLICKED: 'edit_documents_clicked',

  // KYC Agreement events
  KYC_AGREEMENT_PAN_VERIFY_BUTTON_CLICKED: 'kyc_agreement_pan_verify_button_clicked',
  KYC_AGREEMENT_PROCEED_TO_KYC_FAILURE: 'kyc_agreement_proceed_to_kyc_failure',

  // bpcl and company onbaording
  // parent merchant
  // All Merchants Screen Events
  ALL_MERCHANTS_SCREEN_VIEWED: 'all_merchants_screen_viewed',
  ALL_MERCHANTS_SEARCH_PERFORMED: 'all_merchants_search_performed',
  ALL_MERCHANTS_STATUS_FILTER_APPLIED: 'all_merchants_status_filter_applied',
  ALL_MERCHANTS_DOWNLOAD_CLICKED: 'all_merchants_download_clicked',
  ALL_MERCHANTS_SORTING_APPLIED: 'all_merchants_sorting_applied',
  ALL_MERCHANTS_PAGE_CHANGED: 'all_merchants_page_changed',
  ALL_MERCHANTS_MERCHANT_CLICKED: 'all_merchants_merchant_clicked',
  MERCHANT_ONBOARDING_BUTTON_CLICKED: 'merchant_onboarding_button_clicked',

  MERCHANT_ONBOARDING_SCREEN_VIEWED: 'merchant_onboarding_screen_viewed',
  MERCHANT_ONBOARDING_SEARCH_PERFORMED: 'merchant_onboarding_search_performed',
  MERCHANT_ONBOARDING_STAGE_FILTER_APPLIED: 'merchant_onboarding_stage_filter_applied',
  MERCHANT_ONBOARDING_DOWNLOAD_CLICKED: 'merchant_onboarding_download_clicked',
  MERCHANT_ONBOARDING_SORTING_APPLIED: 'merchant_onboarding_sorting_applied',
  MERCHANT_ONBOARDING_PENDING_PAGE_CHANGED: 'merchant_onboarding_pending_page_changed',
  MERCHANT_ONBOARDING_ALL_MERCHANTS_PAGE_CHANGED: 'merchant_onboarding_all_merchants_page_changed',
  MERCHANT_ONBOARDING_TAKE_ACTION_CLICKED: 'merchant_onboarding_take_action_clicked',
  MERCHANT_ONBOARDING_APPROVE_CLICKED: 'merchant_onboarding_approve_clicked',
  MERCHANT_ONBOARDING_REJECT_CLICKED: 'merchant_onboarding_reject_clicked',
  MERCHANT_ONBOARDING_BULK_UPLOAD_HISTORY_CLICKED: 'merchant_onboarding_bulk_upload_history_clicked',
  MERCHANT_ONBOARDING_BULK_ONBOARDING_CLICKED: 'merchant_onboarding_bulk_onboarding_clicked',
  MERCHANT_ONBOARDING_MODAL_CLOSED: 'merchant_onboarding_modal_closed',
  MERCHANT_ONBOARDING_APPROVAL_SUCCESS: 'merchant_onboarding_approval_success',
  MERCHANT_ONBOARDING_APPROVAL_FAILED: 'merchant_onboarding_approval_failed',

  // Bulk Upload History Events
  BULK_UPLOAD_HISTORY_SCREEN_VIEWED: 'bulk_upload_history_screen_viewed',
  BULK_UPLOAD_HISTORY_SEARCH_PERFORMED: 'bulk_upload_history_search_performed',
  BULK_UPLOAD_HISTORY_DATE_RANGE_APPLIED: 'bulk_upload_history_date_range_applied',
  BULK_UPLOAD_HISTORY_SORTING_APPLIED: 'bulk_upload_history_sorting_applied',
  BULK_UPLOAD_HISTORY_PAGE_CHANGED: 'bulk_upload_history_page_changed',
  BULK_UPLOAD_HISTORY_STATUS_REFRESHED: 'bulk_upload_history_status_refreshed',
  BULK_UPLOAD_HISTORY_FILE_DOWNLOADED: 'bulk_upload_history_file_downloaded',

  // adding for pan verification screen
  CIN_ENTERED: 'cin_entered',
  CIN_VERIFICATION_SUCCESS: 'cin_verification_success',
  CIN_VERIFICATION_FAILED: 'cin_verification_failed',
  LLPIN_ENTERED: 'llpin_entered',
  LLPIN_VERIFICATION_SUCCESS: 'llpin_verification_success',
  LLPIN_VERIFICATION_FAILED: 'llpin_verification_failed',
  NO_LLPIN_CHECKBOX_TOGGLED: 'no_llpin_checkbox_toggled',
  GSTIN_AUTO_FETCH_CLICKED: 'gstin_auto_fetch_clicked',
  GSTIN_MODAL_OPENED: 'gstin_modal_opened',
  GSTIN_MODAL_CLOSED: 'gstin_modal_closed',
  GSTIN_SELECTED_FROM_LIST: 'gstin_selected_from_list',
  CITY_SELECTED_FROM_ALTERNATE_LIST: 'city_selected_from_alternate_list',
  ALTERNATE_CITY_LIST_DISPLAYED: 'alternate_city_list_displayed',

  // Parent Bank Details Events
  PARENT_BANK_DETAILS_SCREEN_VIEWED: 'parent_bank_details_screen_viewed',
  PARENT_BANK_PROCEED_CLICKED: 'parent_bank_proceed_clicked',
  PARENT_BANK_RAISE_ISSUE_CLICKED: 'parent_bank_raise_issue_clicked',
  PARENT_BANK_ISSUE_MODAL_OPENED: 'parent_bank_issue_modal_opened',
  PARENT_BANK_ISSUE_MODAL_CLOSED: 'parent_bank_issue_modal_closed',
  PARENT_BANK_ACCOUNT_NUMBER_ENTERED: 'parent_bank_account_number_entered',
  PARENT_BANK_CONFIRM_ACCOUNT_ENTERED: 'parent_bank_confirm_account_entered',
  PARENT_BANK_IFSC_ENTERED: 'parent_bank_ifsc_entered',
  PARENT_BANK_REQUEST_UPDATE_CLICKED: 'parent_bank_request_update_clicked',
  PARENT_BANK_REQUEST_UPDATE_SUCCESS: 'parent_bank_request_update_success',
  PARENT_BANK_REQUEST_UPDATE_FAILED: 'parent_bank_request_update_failed',
  PARENT_BANK_CANCEL_REQUEST_CLICKED: 'parent_bank_cancel_request_clicked',
  PARENT_BANK_CANCEL_REQUEST_SUCCESS: 'parent_bank_cancel_request_success',
  PARENT_BANK_CANCEL_REQUEST_FAILED: 'parent_bank_cancel_request_failed',
  PARENT_BANK_APPROVED_PROCEED_CLICKED: 'parent_bank_approved_proceed_clicked',
  PARENT_BANK_CONFIRM_SELECTION_SUCCESS: 'parent_bank_confirm_selection_success',
  PARENT_BANK_CONFIRM_SELECTION_FAILED: 'parent_bank_confirm_selection_failed',

  // Upload Documents Events
  DOCUMENT_PAGE_LOADED: 'document_page_loaded',
  DOCUMENT_LIST_LOADED: 'document_list_loaded',
  DOCUMENT_UPLOAD_INITIATED: 'document_upload_initiated',
  DOCUMENT_UPLOAD_SUCCESS: 'document_upload_success',
  DOCUMENT_UPLOAD_FAILED: 'document_upload_failed',
  DOCUMENT_REMOVED: 'document_removed',
  DOCUMENT_DOWNLOADED: 'document_downloaded',
  DOCUMENT_TEMPLATE_DOWNLOADED: 'document_template_downloaded',
  DIRECTOR_OPTION_SELECTED: 'director_option_selected',
  DIRECTOR_SELECTED_FROM_LIST: 'director_selected_from_list',
  AUTHORIZED_SIGNATORY_NAME_ENTERED: 'authorized_signatory_name_entered',
  EMAIL_ENTERED_FOR_DIRECTOR: 'email_entered_for_director',
  PROCEED_TO_ESIGN_CLICKED: 'proceed_to_esign_clicked',
  SEND_LINK_CLICKED: 'send_link_clicked',
  ESIGN_URL_GENERATED: 'esign_url_generated',
  ESIGN_URL_GENERATION_FAILED: 'esign_url_generation_failed',
  ESIGN_POPUP_BLOCKED: 'esign_popup_blocked',
  ESIGN_WINDOW_OPENED: 'esign_window_opened',
  ESIGN_WINDOW_CLOSED_BY_USER: 'esign_window_closed_by_user',
  ESIGN_STATUS_SIGNED: 'esign_status_signed',
  ESIGN_STATUS_EXPIRED: 'esign_status_expired',
  ESIGN_STATUS_FAILED: 'esign_status_failed',
  ESIGN_POLLING_ERROR: 'esign_polling_error',
  EMAIL_SENT_SUCCESS: 'email_sent_success',
  EMAIL_SENT_FAILED: 'email_sent_failed',
  REINITIATE_MODAL_OPENED: 'reinitiate_modal_opened',
  REINITIATE_MODAL_CLOSED: 'reinitiate_modal_closed',
  REINITIATE_CONFIRMED: 'reinitiate_confirmed',
  PROCEED_AFTER_EMAIL_SENT: 'proceed_after_email_sent',
  PUBLIC_TOKEN_VALIDATION_SUCCESS: 'public_token_validation_success',
  PUBLIC_TOKEN_VALIDATION_FAILED: 'public_token_validation_failed',
  PUBLIC_ESIGN_SUCCESS_MODAL_SHOWN: 'public_esign_success_modal_shown',
  PDF_DOWNLOAD_SUCCESS: 'pdf_download_success',
  BENEFICIARY_OWNERS_LOADED: 'beneficiary_owners_loaded',
  ERROR_MODAL_CLOSED: 'error_modal_closed',
  PUBLIC_SUCCESS_MODAL_CLOSED: 'public_success_modal_closed',

  // KYC Sign Agreement Events
  KYC_SIGN_AGREEMENT_SCREEN_VIEWED: 'kyc_sign_agreement_screen_viewed',
  KYC_AGREEMENT_PUBLIC_TOKEN_VALIDATION_SUCCESS: 'kyc_agreement_public_token_validation_success',
  KYC_AGREEMENT_PUBLIC_TOKEN_VALIDATION_FAILED: 'kyc_agreement_public_token_validation_failed',
  KYC_AGREEMENT_AUTHORISED_SIGNATORY_SELECTED: 'kyc_agreement_authorised_signatory_selected',
  KYC_AGREEMENT_DIRECTOR_SELECTED: 'kyc_agreement_director_selected',
  KYC_AGREEMENT_PAN_ENTERED: 'kyc_agreement_pan_entered',
  KYC_AGREEMENT_PAN_VERIFIED: 'kyc_agreement_pan_verified',
  KYC_AGREEMENT_PAN_VERIFICATION_FAILED: 'kyc_agreement_pan_verification_failed',
  KYC_AGREEMENT_EKYC_CHECKBOX_CHECKED: 'kyc_agreement_ekyc_checkbox_checked',
  KYC_AGREEMENT_PEP_CHECKBOX_CHECKED: 'kyc_agreement_pep_checkbox_checked',
  KYC_AGREEMENT_STATE_SELECTED: 'kyc_agreement_state_selected',
  KYC_AGREEMENT_PROCEED_TO_KYC_CLICKED: 'kyc_agreement_proceed_to_kyc_clicked',
  KYC_AGREEMENT_DIGILOCKER_URL_GENERATED: 'kyc_agreement_digilocker_url_generated',
  KYC_AGREEMENT_DIGILOCKER_URL_FAILED: 'kyc_agreement_digilocker_url_failed',
  KYC_AGREEMENT_DIGILOCKER_POPUP_BLOCKED: 'kyc_agreement_digilocker_popup_blocked',
  KYC_AGREEMENT_DIGILOCKER_WINDOW_OPENED: 'kyc_agreement_digilocker_window_opened',
  KYC_AGREEMENT_DIGILOCKER_WINDOW_CLOSED: 'kyc_agreement_digilocker_window_closed',
  KYC_AGREEMENT_KYC_VERIFICATION_SUCCESS: 'kyc_agreement_kyc_verification_success',
  KYC_AGREEMENT_KYC_VERIFICATION_FAILED: 'kyc_agreement_kyc_verification_failed',
  KYC_AGREEMENT_SIGN_AGREEMENT_CLICKED: 'kyc_agreement_sign_agreement_clicked',
  KYC_AGREEMENT_PDF_LOADED: 'kyc_agreement_pdf_loaded',
  KYC_AGREEMENT_PDF_LOAD_FAILED: 'kyc_agreement_pdf_load_failed',
  KYC_AGREEMENT_ESIGN_INITIATED: 'kyc_agreement_esign_initiated',
  KYC_AGREEMENT_ESIGN_URL_GENERATED: 'kyc_agreement_esign_url_generated',
  KYC_AGREEMENT_ESIGN_URL_FAILED: 'kyc_agreement_esign_url_failed',
  KYC_AGREEMENT_ESIGN_POPUP_BLOCKED: 'kyc_agreement_esign_popup_blocked',
  KYC_AGREEMENT_ESIGN_WINDOW_OPENED: 'kyc_agreement_esign_window_opened',
  KYC_AGREEMENT_ESIGN_SIGNED: 'kyc_agreement_esign_signed',
  KYC_AGREEMENT_ESIGN_EXPIRED: 'kyc_agreement_esign_expired',
  KYC_AGREEMENT_ESIGN_FAILED: 'kyc_agreement_esign_failed',
  KYC_AGREEMENT_EMAIL_ENTERED: 'kyc_agreement_email_entered',
  KYC_AGREEMENT_SEND_LINK_CLICKED: 'kyc_agreement_send_link_clicked',
  KYC_AGREEMENT_EMAIL_SENT_SUCCESS: 'kyc_agreement_email_sent_success',
  KYC_AGREEMENT_EMAIL_SENT_FAILED: 'kyc_agreement_email_sent_failed',
  KYC_AGREEMENT_RESEND_KYC_LINK_CLICKED: 'kyc_agreement_resend_kyc_link_clicked',
  KYC_AGREEMENT_RESEND_DOCUMENT_LINK_CLICKED: 'kyc_agreement_resend_document_link_clicked',
  KYC_AGREEMENT_VIEW_SUMMARY_CLICKED: 'kyc_agreement_view_summary_clicked',
  KYC_AGREEMENT_EXPLORE_DASHBOARD_CLICKED: 'kyc_agreement_explore_dashboard_clicked',
  KYC_AGREEMENT_ERROR_MODAL_DISPLAYED: 'kyc_agreement_error_modal_displayed',
  KYC_AGREEMENT_SUCCESS_MODAL_DISPLAYED: 'kyc_agreement_success_modal_displayed',
  KYC_AGREEMENT_PENDING_PAGE_VIEWED: 'kyc_agreement_pending_page_viewed',
  KYC_AGREEMENT_COMPLETED_STATUS_SHOWN: 'kyc_agreement_completed_status_shown',

  // Upload Company Document Events
  UPLOAD_COMPANY_DOCUMENT_SCREEN_VIEWED: 'upload_company_document_screen_viewed',
  UPLOAD_COMPANY_DOCUMENT_LOADED: 'upload_company_document_loaded',
  COMPANY_DOCUMENT_UPLOAD_INITIATED: 'company_document_upload_initiated',
  COMPANY_DOCUMENT_UPLOAD_SUCCESS: 'company_document_upload_success',
  COMPANY_DOCUMENT_UPLOAD_FAILED: 'company_document_upload_failed',
  COMPANY_DOCUMENT_REMOVED: 'company_document_removed',
  COMPANY_DOCUMENT_DOWNLOADED: 'company_document_downloaded',
  COMPANY_DOCUMENT_TEMPLATE_DOWNLOADED: 'company_document_template_downloaded',
  BENEFICIARY_OWNERS_QUESTION_ANSWERED: 'beneficiary_owners_question_answered',
  BENEFICIARY_OWNER_PAN_ENTERED: 'beneficiary_owner_pan_entered',
  BENEFICIARY_OWNER_PAN_VERIFY_CLICKED: 'beneficiary_owner_pan_verify_clicked',
  BENEFICIARY_OWNER_PAN_VERIFIED: 'beneficiary_owner_pan_verified',
  BENEFICIARY_OWNER_PAN_VERIFICATION_FAILED: 'beneficiary_owner_pan_verification_failed',
  BENEFICIARY_OWNER_EMAIL_ENTERED: 'beneficiary_owner_email_entered',
  BENEFICIARY_OWNER_OWNERSHIP_ENTERED: 'beneficiary_owner_ownership_entered',
  BENEFICIARY_OWNER_ADDED: 'beneficiary_owner_added',
  BENEFICIARY_OWNER_DELETED: 'beneficiary_owner_deleted',
  BENEFICIARY_OWNERS_SAVE_CLICKED: 'beneficiary_owners_save_clicked',
  BENEFICIARY_OWNERS_SAVED_SUCCESS: 'beneficiary_owners_saved_success',
  BENEFICIARY_OWNERS_SAVED_FAILED: 'beneficiary_owners_saved_failed',
  COMPANY_DOC_DIRECTOR_OPTION_SELECTED: 'company_doc_director_option_selected',
  COMPANY_DOC_DIRECTOR_SELECTED: 'company_doc_director_selected',
  COMPANY_DOC_EMAIL_ENTERED: 'company_doc_email_entered',
  COMPANY_DOC_PROCEED_TO_ESIGN_CLICKED: 'company_doc_proceed_to_esign_clicked',
  COMPANY_DOC_SEND_LINK_CLICKED: 'company_doc_send_link_clicked',
  COMPANY_DOC_ESIGN_URL_GENERATED: 'company_doc_esign_url_generated',
  COMPANY_DOC_ESIGN_URL_FAILED: 'company_doc_esign_url_failed',
  COMPANY_DOC_ESIGN_WINDOW_OPENED: 'company_doc_esign_window_opened',
  COMPANY_DOC_ESIGN_POPUP_BLOCKED: 'company_doc_esign_popup_blocked',
  COMPANY_DOC_ESIGN_SIGNED: 'company_doc_esign_signed',
  COMPANY_DOC_ESIGN_EXPIRED: 'company_doc_esign_expired',
  COMPANY_DOC_ESIGN_FAILED: 'company_doc_esign_failed',
  COMPANY_DOC_EMAIL_SENT_SUCCESS: 'company_doc_email_sent_success',
  COMPANY_DOC_EMAIL_SENT_FAILED: 'company_doc_email_sent_failed',
  COMPANY_DOC_EDIT_REQUEST_CLICKED: 'company_doc_edit_request_clicked',
  COMPANY_DOC_REINITIATE_MODAL_OPENED: 'company_doc_reinitiate_modal_opened',
  COMPANY_DOC_REINITIATE_CONFIRMED: 'company_doc_reinitiate_confirmed',
  COMPANY_DOC_REINITIATE_CANCELLED: 'company_doc_reinitiate_cancelled',
  COMPANY_DOC_KYC_PENDING_PAGE_VIEWED: 'company_doc_kyc_pending_page_viewed',
  COMPANY_DOC_RESEND_KYC_LINK_CLICKED: 'company_doc_resend_kyc_link_clicked',
  COMPANY_DOC_RESEND_KYC_SUCCESS: 'company_doc_resend_kyc_success',
  COMPANY_DOC_RESEND_KYC_FAILED: 'company_doc_resend_kyc_failed',

  // Soft Rejection Events
  SOFT_REJECTION_SCREEN_VIEWED: 'soft_rejection_screen_viewed',
  SOFT_REJECTION_PUBLIC_TOKEN_VALIDATION_SUCCESS: 'soft_rejection_public_token_validation_success',
  SOFT_REJECTION_PUBLIC_TOKEN_VALIDATION_FAILED: 'soft_rejection_public_token_validation_failed',
  SOFT_REJECTION_REASONS_LOADED: 'soft_rejection_reasons_loaded',
  SOFT_REJECTION_DOCUMENT_UPLOAD_INITIATED: 'soft_rejection_document_upload_initiated',
  SOFT_REJECTION_DOCUMENT_UPLOADED: 'soft_rejection_document_uploaded',
  SOFT_REJECTION_DOCUMENT_REMOVED: 'soft_rejection_document_removed',
  SOFT_REJECTION_DOCUMENT_DOWNLOADED: 'soft_rejection_document_downloaded',
  SOFT_REJECTION_TEXT_FIELD_ENTERED: 'soft_rejection_text_field_entered',
  SOFT_REJECTION_URL_FIELD_ENTERED: 'soft_rejection_url_field_entered',
  SOFT_REJECTION_URL_VALIDATION_FAILED: 'soft_rejection_url_validation_failed',
  SOFT_REJECTION_TEXTAREA_ENTERED: 'soft_rejection_textarea_entered',
  SOFT_REJECTION_SUBMIT_CLICKED: 'soft_rejection_submit_clicked',
  SOFT_REJECTION_SUBMIT_SUCCESS: 'soft_rejection_submit_success',
  SOFT_REJECTION_SUBMIT_FAILED: 'soft_rejection_submit_failed',
  SOFT_REJECTION_VALIDATION_ERROR: 'soft_rejection_validation_error',
  SOFT_REJECTION_PUBLIC_VIEW_LOADED: 'soft_rejection_public_view_loaded',
  SOFT_REJECTION_PREFILLED_DATA_LOADED: 'soft_rejection_prefilled_data_loaded',
  FETCHING_WALLET_NAMES_FAILED: 'get_wallet_names_filter_api_failed',

  // CKYC Flow Events
  CKYC_MOBILE_MODAL_OPENED: 'ckyc_mobile_modal_opened',
  CKYC_MOBILE_NUMBER_ENTERED: 'ckyc_mobile_number_entered',
  CKYC_CONSENT_CHECKBOX_CHECKED: 'ckyc_consent_checkbox_checked',
  CKYC_GET_VERIFICATION_CODE_CLICKED: 'ckyc_get_verification_code_clicked',
  CKYC_OTP_SENT_SUCCESS: 'ckyc_otp_sent_success',
  CKYC_OTP_SENT_FAILED: 'ckyc_otp_sent_failed',
  CKYC_OTP_MODAL_OPENED: 'ckyc_otp_modal_opened',
  CKYC_OTP_ENTERED: 'ckyc_otp_entered',
  CKYC_OTP_VERIFIED_SUCCESS: 'ckyc_otp_verified_success',
  CKYC_OTP_VERIFIED_FAILED: 'ckyc_otp_verified_failed',
  CKYC_RESEND_CODE_CLICKED: 'ckyc_resend_code_clicked',
  CKYC_EDIT_MOBILE_CLICKED: 'ckyc_edit_mobile_clicked',
  CKYC_CONSENT_MODAL_OPENED: 'ckyc_consent_modal_opened',
  CKYC_CONSENT_PROCEED_CLICKED: 'ckyc_consent_proceed_clicked',
  CKYC_DATA_DOWNLOAD_SUCCESS: 'ckyc_data_download_success',
  CKYC_DATA_DOWNLOAD_FAILED: 'ckyc_data_download_failed',

  // kyc flow
  KYC_REDO_CKYC_CLICKED: 'kyc_redo_ckyc_clicked',
  KYC_CKYC_CONSENT_CHECKBOX_CHECKED: 'kyc_ckyc_consent_checkbox_checked',
  KYC_PEP_CHECKBOX_TOGGLED: 'kyc_pep_checkbox_toggled',
  KYC_PEP_STATE_SELECTED: 'kyc_pep_state_selected',
  KYC_CONFIRM_AND_PROCEED_CLICKED: 'kyc_confirm_and_proceed_clicked',

  // kyc agreement flow
  KYC_AGREEMENT_PROCEED_TO_VIDEO_KYC_CLICKED: 'kyc_agreement_proceed_to_video_kyc_clicked',
  VKYC_OFF_HOURS_RESTRICTION: 'vkyc_off_hours_restriction',
  VKYC_URL_GENERATION_FAILED: 'vkyc_url_generation_failed',
  VKYC_URL_GENERATED: 'vkyc_url_generated',
  VKYC_POPUP_BLOCKED: 'vkyc_popup_blocked',
  VKYC_WINDOW_OPENED: 'vkyc_window_opened',
  VKYC_WINDOW_CLOSED: 'vkyc_window_closed',
};

export const PG_EDGE_ID = 1;
export const PLURAL_ID = 2;
export const PAYOUT_ID = 3;
export const SUBSCRIPTION_ID = 4;

// URL Path to Product ID mapping
export const PATH_TO_PRODUCT_ID_MAP = {
  'subscription': SUBSCRIPTION_ID,
  'payout': PAYOUT_ID,
  'edge': PG_EDGE_ID,
  'plural': PLURAL_ID,
  'payment-gateway': PG_EDGE_ID,
};

export const OPS_ADMIN = 'Ops Admin';

export const SOURCE_SYSTEM = 'PLURAL';

export const imageURLs = {
  updated_cross_icon: `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM11.3744 4.62492C11.7649 5.01545 11.7649 5.64861 11.3744 6.03914L9.41486 7.9987L11.3744 9.95826C11.7649 10.3488 11.7649 10.9819 11.3744 11.3725C10.9839 11.763 10.3507 11.763 9.96021 11.3725L8.00065 9.41291L6.04109 11.3725C5.65057 11.763 5.0174 11.763 4.62688 11.3725C4.23635 10.9819 4.23635 10.3488 4.62688 9.95826L6.58644 7.9987L4.62688 6.03914C4.23635 5.64861 4.23635 5.01545 4.62688 4.62492C5.0174 4.2344 5.65057 4.2344 6.04109 4.62492L8.00065 6.58448L9.96021 4.62492C10.3507 4.2344 10.9839 4.2344 11.3744 4.62492Z" fill="#stroke#DA0001"/>
  </svg>
  `
};

export const merchantVersionUpdateEmailIdsList = [
  'sanjeev.rai@pinelabs.com',
  'shashank.varshney@pinelabs.com',
  'shiva.sankaran@pinelabs.com',
  'k.dhakshinamoorthy@pinelabs.com',
  'garima.chitre@pinelabs.com',
  'anurag.dixit@pinelabs.com',
  'ankit.aneja@pinelabs.com',
];

Object.freeze(merchantVersionUpdateEmailIdsList);

export const MAX_DATE_RANGE_DAYS_REPORTS = 31;

export const USER_VERIFICATION_SCREENS_CONSTANTS = {
  labels: {
    PRODUCTS: 'Product',
    SELECT_FROM_BELOW: 'The following product is available for you',
    PERFECT_FOR_WEBSITE_AND_APP_PAYMENT: 'Perfect for website and app payments',
    MORE: 'More',
    CONFIRM_PRODUCTS: 'Confirm Products',
    SELECTED: 'SELECTED',
    PAN_NUMBER: 'PAN number',
    PERSONAL_PAN: 'Personal PAN',
    PAN: 'PAN',
    ENTER_CIN: 'Enter CIN of the company',
    ENTER_LLPIN: 'Enter LLPIN of the company',
    ENTER_PAN_NUMBER: 'Enter your PAN number',
    ENTER_GST_NUMBER: 'Enter your GST number',
    ENTER_BUSINESS_ADDRESS: 'Enter your Business Address',
    GST_NUMBER: 'GST number',
    PAN_DETAILS: 'PAN details',
    GST_DETAILS: 'GST details',
    NAME: 'Name',
    LEGAL_NAME: 'Legal Name',
    TRADE_NAME: ' Trade Name',
    BUSINESS_ADDRESS: 'Business Address',
    PAN_AND_GST_DETAIL: 'Enter your PAN',
    SAVE_NEXT: 'Save and continue',
    VERIFY_PAN: 'Verify PAN',
    VERIFY_CIN: 'Verify CIN',
    VERIFY_LLPIN: 'Verify LLPIN',
    VERIFY_YOUR_BUSINESS: 'We will use this to verify your business',
    BUSINESS_DETAILS: 'Website details',
    IMPORTANT_WEBSITE_LINKS: 'Important website links',
    FILL_THE_LINKS: 'You need to fill these links to start accepting online payments',
    BUSINESS_WEBSITE_URL: 'Website URL',
    PRIVACY_POLICY_URL: 'Privacy Policy URL',
    APP_URL: 'Mobile app URL',
    REFUND_AND_CANCELLATION_POLICY_URL: 'Refund and Cancellation Policy URL',
    EXAMPLE_URL: 'https://example.com',
    BASIC_BUSINESS_DETAILS: 'Basic details',
    RBI_MANDATE_INFORMATION: 'This information is mandated as per RBI guidelines',
    ANNUAL_TURNOVER: 'Annual Turnover',
    SELECT_ANNUAL_TURNOVER: 'Select Your Annual Turnover',
    BUSINESS_CATEGORY: 'Business Category',
    BUSINESS_SUB_CATEGORY: 'Business Sub-Category',
    SELECT_BUSINESS_CATEGORY: 'Select Business Category',
    SELECT_BUSINESS_SUB_CATEGORY: 'Select Business Sub-Category',
    KYC_VERIFICATION: 'KYC verification',
    COMPLETE_YOUR_KYC: 'Complete your KYC using any proof of identity',
    PROOF_OF_IDENTITY: 'Proof of Identity',
    ID_NO: 'ID no.',
    DATE_OF_BIRTH: 'Date of Birth',
    GENDER: 'Gender',
    ADDRESS: 'Address',
    VERIFY_IDENTITY: 'Verify Identity',
    ALLOW_E_KYC: 'I allow eKYC to obtain my details through DigiLocker and agree to the',
    AADHAAR_E_KYC_TERMS_AND_CONDITION: 'Aadhaar eKYC Terms & Conditions',
    BANK_ACCOUNT: 'Bank account',
    SPECIFY_BANK_ACCOUNT_DETAILS: 'Your payments will be settled in this account',
    ACCOUNT_HOLDER_NAME_VALID: 'The account holder’s name should match your legal name, or the application may be rejected.',
    NOTE: 'NOTE:',
    SEND_RUPPE_TO_VERIFY_DETAIL: 'Send ₹1 using UPI to auto-fill and verify your bank details',
    YOUR_MONEY_WILL_BE_REFUNDED: 'Your money will be refunded after auto-filling',
    SCAN_QR_CODE: 'Scan QR code',
    ENTER_UPI_ID: 'Enter UPI ID',
    UNABLE_TO_VERIFY: 'Unable to verify?',
    ENTER_MANUALLY: 'Enter Manually',
    BANK_ACCOUNT_NUMBER: 'Bank account number',
    ENTER_BANK_ACCOUNT_NUMBER: 'Enter bank account number',
    IFSC_CODE: 'IFSC Code',
    ENTER_BANK_IFSC_CODE: 'Enter bank’s IFSC code',
    ACCOUNT_TYPE: 'Account type',
    SELECT_ACCOUNT_NUMBER: 'Select account type',
    NO_REMENBER_ACCOUNT_NUMBER: 'Don’t remember account number?',
    TRY_AUTO_FILL: 'Try auto_filling through UPI',
    VERIFIED: 'Verified',
    WANT_DIFFRENT_ACCOUNT: 'Want a different account for settlements?',
    CHANGE_BANK_ACCOUNT: 'Change Bank Account',
    REVIEW_ALL_DETAILS: 'Review all details',
    MAKE_SURE_ALL_DETAILS_AREVALID: 'Make sure all the details shown are correct',
    PROFILE_SUBMITTED: 'Your KYC is submitted, you can start accepting payments',
    YOU_CAN_NOW: 'You can now,',
    ACCESS_THE_DASHBOARD: 'Access the dashboard',
    GET_LIVE_INEGARTION_CREDENTIAL: 'Get live integration credentials right away',
    START_ACCEPTING: 'Accept UPI and Card payments',
    EDIT: 'Edit',
    YOU_ARE_IN_TEST_ENV: "You're in <b>Test Environment</b> - Only test transactions will be processed.",
    YOU_ARE_IN_LIVE_ENV: "You're in <b>Live Environment.</b>",
    TEST_MODE: 'Test Mode',
    LIVE_MODE: 'Live Mode',
    EMAIL_VERIFIED: 'Email has been verified',
    PLEASE_PROCEED_TO_LOGIN: 'Please proceed to login',
    PROCEED_TO_LOGIN: 'Proceed to login',
    VERIFICATION_LINK_EXPIRED: 'Email verification link expired',
    PLEASE_REQUEST_NEW_LINK:
      'Please  request a new verification  link to complete your account setup',
    RESEND_EMAIL: 'Resend email',
    EMAIL_ALREADY_VERIFIED: 'Email already verified',
    ISSUE_WITH_UPLOADED_DOC: 'Issue with uploaded documents',
    KINDLY_REUPLOAD_THE_DOC: "Kindly re-upload business proof document: Your previous submission of the 'Shop & Establishment Certificate' <br/> image was unclear and needs to be resubmitted.",
    FOR_ADDITIONAL_SUPPORT: 'For any additional support, please write an email to <span>pgsupport@pinelabs.com</span>',
    BUSINESS_PROOF: 'Business Proof',
    UPLOAD_BUSINESS_PROOF: 'Upload business proof document',
    UPLOAD: 'Upload',
    SELECT_THE_BUSINESS_PROOF_TO_BE_UPLOADED: 'Select the business proof to pe uploaded',
    PAN_GST_SUBHEADING: "We'll use your PAN for KYC verification and to fetch your GST details",
    KYC_AGREEMENT_SIGN: 'KYC Verification & Agreement Signing',
    SIGN_AGREEMENT_COPY: 'Sign Agreement Copy',
    PROCEED_TO_KYC: 'Proceed to KYC',
    MUST_BE_LEGALLY_AUTHORISED: 'This step must be completed by the person legally authorised to sign on behalf of your company',
    ARE_YOU_AUTHORISED_SIGNATORY: 'Are you an authorised signatory?',
    // Bank Account
    ENTER_YOUR_BANK_DETAILS: 'Enter the bank account to receive settlements',
    CONFIRM_BANK_ACCOUNT_NUMBER: 'Confirm bank account number',
    RE_ENTER_BANK_ACCOUNT_NUMBER: 'Re-enter your bank account number',
    VERIFY_ACCOUNT_DETAILS: 'Verify account details',
    BANK_VERIFICATION_FAILED: 'Bank Verification Failed',
    SOMETHING_WENT_WRONG_BANK_VERIFICATION: 'Something went wrong while verifying bank details.',
    EDITING_FIELD_RE_VERIFICATION: 'Editing this field might need re-verification',
    ACCOUNT_HOLDER_NAME_MISMATCH: "Account holder name doesn't match your PAN.",
    EDIT_PAN_DETAILS: 'Edit PAN details',
    VERIFYING: 'Verifying',
    // KYC
    KYC_VERIFICATION_FAILED: 'KYC Verification Failed',
    CONFIRM_AND_PROCEED: 'Confirm and Proceed',
    CONTINUE_TO_DIGILOCKER: 'Continue to DigiLocker',
    DIGILOCKER_HEADING: 'We will take you to DigiLocker to verify your details',
    DIGILOCKER_DESCRIPTION: 'DigiLocker is a portal of the Government of India, which allows you to securely and quickly share digital copies of your documents with us.',
    REDO_CKYC: 'Re-do CKYC',
    REDO_KYC: 'Redo KYC',
    SUBMIT_CKYC_DETAILS: 'Submit my CKYC details',
    POLITICALLY_EXPOSED_LABEL: 'I am a politically exposed/related to a politically exposed person.',
    SELECT_STATE_JURISDICTION: 'Select State in which your jurisdiction is held',
    SELECT_STATE: 'Select State',
    ALLOW_EKYC_DIGILOCKER: 'I allow eKYC through DigiLocker.',
    PLEASE_ALLOW_POPUPS: 'Please allow popups.',
    // Review Details
    REVIEW_FINAL_WARNING: "This is your final review. Edits won't be allowed after this step.",
    REVIEW_MERCHANT_AGREEMENT: 'Review Merchant Agreement',
    MERCHANT_AGREEMENT: 'Merchant Agreement',
    COULD_NOT_FETCH_AGREEMENT: 'Could not fetch merchant agreement. Please try again.',
    BO_DETAILS: 'B.O. Details',
    BO_KYC_COMPLETED: 'B.O. KYC is completed',
    BO_KYC_PENDING: 'B.O. KYC is pending',
    DIRECTORS_ESIGN_COMPLETED: 'Directors e-sign is completed',
    SETUP_FEE_TITLE: 'Limited time offer',
    SETUP_FEE_ORIGINAL_PRICE: '₹15,000',
    SETUP_FEE_DISCOUNTED_PRICE: '₹0 Setup fee',
    SETUP_FEE_BENEFIT_1: 'Dedicated integrations manager for personalized support',
    SETUP_FEE_BENEFIT_2: 'Swift account verification within 24 hours',
    SETUP_FEE_BENEFIT_3: 'Zero MDR for the first month',
    SETUP_FEE_BENEFIT_4: 'Instant onboarding within 30 minutes',
    SETUP_FEE_BENEFIT_5: '100+ payment methods ',
    SETUP_FEE_BENEFIT_6: 'Widest EMI coverage',
    SETUP_FEE_BENEFIT_7: 'UPI at Lowest Fees',
    NO_DOCUMENTS_UPLOADED: 'No documents uploaded',
    VIEW_MORE: 'View More',
    // Validation
    BANK_ACCOUNT_REQUIRED: 'Bank account number is required',
    BANK_ACCOUNT_DIGITS_ONLY: 'Bank account number must contain only digits',
    BANK_ACCOUNT_MIN_LENGTH: 'Bank account number must be at least 9 digits',
    BANK_ACCOUNT_MAX_LENGTH: 'Bank account number cannot exceed 18 digits',
    RE_ENTER_ACCOUNT_NUMBER: 'Please re-enter your bank account number',
    ACCOUNT_NUMBERS_DO_NOT_MATCH: 'Account numbers do not match',
    IFSC_REQUIRED: 'IFSC code is required',
    IFSC_LENGTH_ERROR: 'IFSC code must be exactly 11 characters',
    IFSC_INVALID: 'Enter a valid IFSC code (e.g. SBIN0000233)',
    // Common
    SOMETHING_WENT_WRONG: 'Something went wrong, please try again',
    OKAY: 'Okay',
    NAVIGATION_FAILED: 'Navigation failed',
    BUSINESS_DETAILS_SUBTITLE: 'Add your website to verify your business type',
  }
};

export const currencyMapper = {
  INR: {
    symbol: "₹",
    flag: "https://d1xlp3rxzdtgvz.cloudfront.net/country-flags/INR.svg",
    transformation_ratio: 2
  },
  USD: {
    symbol: "$",
    flag: "https://d1xlp3rxzdtgvz.cloudfront.net/country-flags/USD.svg",
    transformation_ratio: 2
  },
  EUR: {
    symbol: "€",
    flag: "https://d1xlp3rxzdtgvz.cloudfront.net/country-flags/EUR.svg",
    transformation_ratio: 2
  },
  GBP: {
    symbol: "£",
    flag: "https://d1xlp3rxzdtgvz.cloudfront.net/country-flags/GBP.svg",
    transformation_ratio: 2
  },
  AUD: {
    symbol: "A$",
    flag: "https://d1xlp3rxzdtgvz.cloudfront.net/country-flags/AUD.svg",
    transformation_ratio: 2
  },
  CHF: {
    symbol: "CHF",
    flag: "https://d1xlp3rxzdtgvz.cloudfront.net/country-flags/CHF.svg",
    transformation_ratio: 2
  },
  SGD: {
    symbol: "S$",
    flag: "https://d1xlp3rxzdtgvz.cloudfront.net/country-flags/SGD.svg",
    transformation_ratio: 2
  },
  JPY: {
    symbol: "¥",
    flag: "https://d1xlp3rxzdtgvz.cloudfront.net/country-flags/JPY.svg",
    transformation_ratio: 1
  },
  HKD: {
    symbol: "HK$",
    flag: "https://d1xlp3rxzdtgvz.cloudfront.net/country-flags/HKD.svg",
    transformation_ratio: 2
  },
  AED: {
    symbol: "د.إ",
    flag: "https://d1xlp3rxzdtgvz.cloudfront.net/country-flags/AED.svg",
    transformation_ratio: 2
  },
  NZD: {
    symbol: "NZ$",
    flag: "https://d1xlp3rxzdtgvz.cloudfront.net/country-flags/NZD.svg",
    transformation_ratio: 2
  },
  DKK: {
    symbol: "kr",
    flag: "https://d1xlp3rxzdtgvz.cloudfront.net/country-flags/DKK.svg",
    transformation_ratio: 2
  },
  SEK: {
    symbol: "kr",
    flag: "https://d1xlp3rxzdtgvz.cloudfront.net/country-flags/SEK.svg",
    transformation_ratio: 2
  },
  NOK: {
    symbol: "kr",
    flag: "https://d1xlp3rxzdtgvz.cloudfront.net/country-flags/NOK.svg",
    transformation_ratio: 2
  },
  CAD: {
    symbol: "C$",
    flag: "https://d1xlp3rxzdtgvz.cloudfront.net/country-flags/CAD.svg",
    transformation_ratio: 2
  },
  ZAR: {
    symbol: "R",
    flag: "https://d1xlp3rxzdtgvz.cloudfront.net/country-flags/ZAR.svg",
    transformation_ratio: 2
  },
  CNY: {
    symbol: "¥",
    flag: "https://d1xlp3rxzdtgvz.cloudfront.net/country-flags/CNY.svg",
    transformation_ratio: 2
  },
  THB: {
    symbol: "฿",
    flag: "https://d1xlp3rxzdtgvz.cloudfront.net/country-flags/THB.svg",
    transformation_ratio: 2
  },
  BDT: {
    symbol: "৳",
    flag: "https://d1xlp3rxzdtgvz.cloudfront.net/country-flags/BDT.svg",
    transformation_ratio: 2

  },
  BGN: {
    symbol: "лв",
    flag: "https://d1xlp3rxzdtgvz.cloudfront.net/country-flags/BGN.svg",
    transformation_ratio: "2"

  },
  BHD: {
    symbol: ".د.ب",
    flag: "https://d1xlp3rxzdtgvz.cloudfront.net/country-flags/BHD.svg",
    transformation_ratio: "3"
  },
  BRL: {
    symbol: "R$",
    flag: "https://d1xlp3rxzdtgvz.cloudfront.net/country-flags/BRL.svg",
    transformation_ratio: "2"
  },
  BWP: {
    symbol: "P",
    flag: "https://d1xlp3rxzdtgvz.cloudfront.net/country-flags/BWP.svg",
    transformation_ratio: "2"
  },
  CRC: {
    symbol: "₡",
    flag: "https://d1xlp3rxzdtgvz.cloudfront.net/country-flags/CRC.svg",
    transformation_ratio: "2"
  },
  CZK: {
    symbol: "Kč",
    flag: "https://d1xlp3rxzdtgvz.cloudfront.net/country-flags/CZK.svg",
    transformation_ratio: "2"
  },
  EGP: {
    symbol: "£",
    flag: "https://d1xlp3rxzdtgvz.cloudfront.net/country-flags/EGP.svg",
    transformation_ratio: "2"
  },
  HUF: {
    symbol: "Ft",
    flag: "https://d1xlp3rxzdtgvz.cloudfront.net/country-flags/HUF.svg",
    transformation_ratio: "2"
  },
  ILS: {
    symbol: "₪",
    flag: "https://d1xlp3rxzdtgvz.cloudfront.net/country-flags/ILS.svg",
    transformation_ratio: "2"
  },
  ISK: {
    symbol: "kr",
    flag: "https://d1xlp3rxzdtgvz.cloudfront.net/country-flags/ISK.svg",
    transformation_ratio: "2"
  },
  JOD: {
    symbol: "د.ا",
    flag: "https://d1xlp3rxzdtgvz.cloudfront.net/country-flags/JOD.svg",
    transformation_ratio: "3"
  },
  KES: {
    symbol: "KSh",
    flag: "https://d1xlp3rxzdtgvz.cloudfront.net/country-flags/KES.svg",
    transformation_ratio: "2"
  },
  KRW: {
    symbol: "₩",
    flag: "https://d1xlp3rxzdtgvz.cloudfront.net/country-flags/KRW.svg",
    transformation_ratio: "0"
  },
  KWD: {
    symbol: "د.ك",
    flag: "https://d1xlp3rxzdtgvz.cloudfront.net/country-flags/KWD.svg",
    transformation_ratio: "3"
  },
  LKR: {
    symbol: "Rs",
    flag: "https://d1xlp3rxzdtgvz.cloudfront.net/country-flags/LKR.svg",
    transformation_ratio: "2"
  },
  MAD: {
    symbol: "د.م.",
    flag: "https://d1xlp3rxzdtgvz.cloudfront.net/country-flags/MAD.svg",
    transformation_ratio: "2"
  },
  MUR: {
    symbol: "₨",
    flag: "https://d1xlp3rxzdtgvz.cloudfront.net/country-flags/MUR.svg",
    transformation_ratio: "2"
  },
  MYR: {
    symbol: "RM",
    flag: "https://d1xlp3rxzdtgvz.cloudfront.net/country-flags/MYR.svg",
    transformation_ratio: "2"
  },
  NPR: {
    symbol: "Rs",
    flag: "https://d1xlp3rxzdtgvz.cloudfront.net/country-flags/NPR.svg",
    transformation_ratio: "2"
  },
  OMR: {
    symbol: "ر.ع.",
    flag: "https://d1xlp3rxzdtgvz.cloudfront.net/country-flags/OMR.svg",
    transformation_ratio: "3"
  },
  PEN: {
    symbol: "S/.",
    flag: "https://d1xlp3rxzdtgvz.cloudfront.net/country-flags/PEN.svg",
    transformation_ratio: "2"
  },
  PHP: {
    symbol: "₱",
    flag: "https://d1xlp3rxzdtgvz.cloudfront.net/country-flags/PHP.svg",
    transformation_ratio: "2"
  },
  PKR: {
    symbol: "Rs",
    flag: "https://d1xlp3rxzdtgvz.cloudfront.net/country-flags/PKR.svg",
    transformation_ratio: "2"
  },
  PLN: {
    symbol: "zł",
    flag: "https://d1xlp3rxzdtgvz.cloudfront.net/country-flags/PLN.svg",
    transformation_ratio: "2"
  },
  QAR: {
    symbol: "ر.ق",
    flag: "https://d1xlp3rxzdtgvz.cloudfront.net/country-flags/QAR.svg",
    transformation_ratio: "2"
  },
  RON: {
    symbol: "lei",
    flag: "https://d1xlp3rxzdtgvz.cloudfront.net/country-flags/RON.svg",
    transformation_ratio: "2"
  },
  SAR: {
    symbol: "ر.س",
    flag: "https://d1xlp3rxzdtgvz.cloudfront.net/country-flags/SAR.svg",
    transformation_ratio: "2"
  },
  TND: {
    symbol: "د.ت",
    flag: "https://d1xlp3rxzdtgvz.cloudfront.net/country-flags/TND.svg",
    transformation_ratio: "3"
  },
  TRY: {
    symbol: "₺",
    flag: "https://d1xlp3rxzdtgvz.cloudfront.net/country-flags/TRY.svg",
    transformation_ratio: "2"
  },
  TWD: {
    symbol: "NT$",
    flag: "https://d1xlp3rxzdtgvz.cloudfront.net/country-flags/TWD.svg",
    transformation_ratio: "2"
  },
  TZS: {
    symbol: "TSh",
    flag: "https://d1xlp3rxzdtgvz.cloudfront.net/country-flags/TZS.svg",
    transformation_ratio: "2"
  },
  UGX: {
    symbol: "USh",
    flag: "https://d1xlp3rxzdtgvz.cloudfront.net/country-flags/UGX.svg",
    transformation_ratio: "0"
  },
  VND: {
    symbol: "₫",
    flag: "https://d1xlp3rxzdtgvz.cloudfront.net/country-flags/VND.svg",
    transformation_ratio: "1"
  },
};

export const PCI_DSS_CONSTANTS = {
  DOCUMENT_TYPE: 'PCI_DSS',
  SUPPORT_EMAIL: 'pgsupport@pinelabs.com',
  SAQ_GENERATION_STATUS: {
    COMPLETED: 'COMPLETED',
    FAILED: 'FAILED',
    PENDING: 'PENDING',
  },
  labels: {
    INFO_BANNER_TEXT: "Don't have a PCI DSS certificate? Please go through the",
    INFO_BANNER_CONTACT_TEXT: 'and confirm your compliance with PCI DSS requirements. If you need clarification on any guideline in the self assessment declaration, please contact',
    INFO_BANNER_CONTACT_SUFFIX: 'before proceeding. Our team will assist you.',
    SAQ_LINK_TEXT: 'self assessment declaration',
    CHECKBOX_LABEL: 'I confirm that I comply with all PCI DSS requirements outlined in the',
    SAQ_LINK_LABEL: 'self assessment declaration.',
    SAQ_GENERATION_FAILED: 'SAQ generation failed. Please try again.',
    CONSENT_UPDATE_FAILED: 'Failed to update PCI DSS consent. Please try again.',
    REVIEW_INFO_BANNER_TEXT: 'If you need clarification on any guideline in the self assessment declaration, please contact',
  },
};
